/**
 * Created by senani on 12/18/18.
 */

import React, {Component} from "react";
import CartItem from '../CartItem/CartItem';
import "./CartRow.css";
import {FormattedMessage} from "react-intl";
import CartItemDelete from "../CartItemDelete/CartItemDelete";
import {Link} from 'react-router-dom';
import CartPrint from "../CartPrint/CartPrint";
import edit_cart from "../../../../assets/img/edit_cart.png";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import Modal from "react-bootstrap/lib/Modal";
import delete_cart from "../../../../assets/img/delete_cart.png";

class CartRow extends Component {
    constructor(props) {
        super(props);

        this.setEditMode = this.setEditMode.bind(this);
    }

    setEditMode = () => {
        InitialQuotationState.cartItemEditMode = true;
    };


    render() {
        let checked = this.props.checkedItems.includes(this.props.items.id);

        return (
            <div className="container-fluid cart-row-container">
                {/*<div className="spacer "></div>*/}
                <div className="row ">
                    <div className="col-md-1 no-padding">
                        <input type="checkbox" onChange={() => this.props.toggleItem(this.props.items.id)}
                               checked={checked}/>
                    </div>
                    <div className="col-md-6 no-padding">
                        <div className="">
                            <div className="row">
                                <CartItem itemDetails={this.props.items}/>

                            </div>
                            {/*<div className="gerber-view">ガーバービューア</div>*/}

                        </div>
                    </div>
                    {/*{this.props.items.unitPrice}*/}
                    <div className="col-md-2">
                        <span className="right-align total-price-text align-text-content">
                            ¥<NumberFormatter num={this.props.items.chargeDetails.totalPrice}/>
                        </span>

                    </div>
                    <div className="col-md-2 cart-action-div">
                        {localStorage.getItem("userRole") !== "ROLE_IMPERSONATE" ?
                            <div className="row cart-action-btn-div cart-row-text-color" onClick={this.setEditMode}>
                                <Link to={'quotation/edit/' + this.props.items.id}>
                                    {/*<span className="btn btn-warning cart-action-btn cart-edit-btn">
                            <FormattedMessage id="app.cart.edit-link"
                                              defaultMessage="Edit"
                                              description=""/>
                        </span>*/}
                                    <img src={edit_cart} className="cart-row-text-color"/>&nbsp;
                                    <label className="cart-row-text-color">数量変更</label>

                                </Link>
                            </div> :
                            <div className="row cart-action-btn-div tooltipCartRow">
                                <span className="tooltiptextCartRow">アクセスが拒否されました</span>
                                <img src={edit_cart} />&nbsp;
                                <label className="">数量変更</label>
                            </div>}
                        <div className="row cart-action-btn-div">
                            {localStorage.getItem("userRole") !== "ROLE_IMPERSONATE" ?
                                <CartItemDelete itemDetails={this.props.items}
                                                checkedItems={this.props.checkedItems}
                                                userId={this.props.userId}
                                                getCartItems={this.props.getCartItems}
                                                onCartItemDeleted={this.props.onCartItemDeleted}/>
                                                :
                                <div className="row cart-action-btn-div tooltipCartRow">
                                    <span className="tooltiptextCartRow">アクセスが拒否されました</span>
                                    <img src={delete_cart} alt="delete"/>
                                    &nbsp;<label>削除</label>
                                </div>}
                        </div>
                        <div className="row cart-action-btn-div print-cart-quotation-resp">
                            <CartPrint itemDetails={this.props.items}
                                       userId={this.props.userId}
                                       getCartItems={this.props.getCartItems}
                                       checkedItems={this.props.checkedItems}/>
                        </div>

                    </div>
                </div>
                <br/>
            </div>
        )
    }
}

export default CartRow;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartRow/CartRow.js